import { render, staticRenderFns } from "./LicenseDetails.html?vue&type=template&id=6336145b&"
import script from "./LicenseDetails.js?vue&type=script&lang=js&"
export * from "./LicenseDetails.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports